import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { tagTypes } from "./tags";
import { endpoints } from "./endpoints";
import CryptoJS from "crypto-js";
const secretKey = '3xA6QlyA_4f]My47)IUm-wG({t")a$';
export const getTokenFromLocalStorage = () => {
  const encryptedToken = localStorage.getItem("token");

  if (encryptedToken) {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
      const decryptedToken = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      return localStorage.getItem(decryptedToken);
    } catch (err) {
      console.error("Token decryption failed:", err);
    }
  }
};

// Define a service using a base URL and expected endpoints
export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  tagTypes: tagTypes,
  endpoints: endpoints,
});

export const {
  usegetUpcomingTrainingListQuery,
  usegetCompletedTrainingListQuery,
  useGetAllTableRecordsQuery,
  useGetAllSchemeInterestQuery,
  useMeQuery,
  useUpdateUserMutation,
  useUserDetailsMutation,
  useUserTypeDetailsQuery,
  useGetUserDetailsQuery,
  useResetPasswordMutation,

  useLoginUserMutation,
  useGetRoleByDesignationQuery,

  useGetPmKisanDataQuery,
  useGetDistrictListQuery,
  useGetRdBlockListQuery,
  useSinglePmKisanDataQuery,
  useGetSsoDataMutation,

  useGetWeatherStationListQuery,
  useCreateWeatherStationMutation,
  useUpdateWeatherStationMutation,
  useRefreshWeatherDataMutation,
  useGethWeatherDataListQuery,
  useGetAllWeatherDataListQuery,

  // city weather
  useRefreshSingleCityWeatherMutation,
  useRefreshCityWeatherMutation,
  useGetCityWeatherListQuery,

  useGetAllDesignationListQuery,
  useGetAllUserQuery,

  useCreateSdscoMutation,
  useGetAllSdscoQuery,
  useGetSingleSdscoQuery,
  useUpdateSdscoMutation,

  useGetAllSoilSectionQuery,
  useCreateSoilSectionMutation,
  useGetSingleSoilSectionQuery,
  useUpdateSoilSectionMutation,

  useGetAllFarmerInterestQuery,

  useGetAllCropMasterQuery,

  useCreateCropAdvisoryMutation,
  useGetAllCropAdvisoryQuery,
  useGetSingleCropAdvisoryQuery,
  useUpdateCropAdvisoryMutation,

  useUpdateGrievanceMutation,
  useGetAllGrievanceListQuery,

  useCreateCreatorMutation,
  useGetAllCreatorListQuery,
  useGetSingleCreatorQuery,
  useUpdateCreatorMutation,
  useGetReviewLogsQuery,

  useGetAllSchemeMasterListQuery,

  useGetAllCropDiseaseLogListQuery,

  useGetAllFarmerListQuery,

  /*AGRI STACK*/
  useGetOwnerCodeDetailsMutation,
  useGetLandDetailsMutation,
  /*END HERE*/

  /*Village*/
  useGetVillageListQuery,
  useCreateBioFlocsMutation,
  useUpdateBioFlocsMutation,
  useGetBioFlocListQuery,

  useGetVehicleListQuery,
  useCreateVehicleMutation,
  useUpdateVehicleMutation,

  useGetPondsListQuery,
  useCreatePondsMutation,
  useUpdatePondsMutation,

  useGetHrBlocksListQuery,
  useGetHrVillagesListQuery,

  useEditPondsQuery,
  /*END HERE*/
  useGetSchemeListQuery,
  //=========================Lease and farmers========================//
  useGetFarmersListQuery,
  useGetLeaseListQuery,
  useCreateLeaseMutation,
  usePostLeaseMutation,
  useGetSingleLeaseQuery,

  useGetCultureListQuery,
  useGetSepCultureListBioFlocQuery,
  useCreateCultureMutation,
  useCreateCultureBioFlocMutation,
  useUpdateCultureMutation,
  useUpdateCultureBioFlocMutation,
  useGetFishVarietyListQuery,
  useGetSingleCultureQuery,

  useGetFishProductionListQuery,
  useGetFishProductionListBioFlocQuery,

  useCreateFishProductionMutation,
  useCreateFishProductionBioFlocMutation,

  useUpdateFishProductionMutation,
  useUpdateFishProductionBioFlocMutation,
  // useGetFishVarietyListQuery,
  useGetSingleFishProductionQuery,
  useGetSingleFarmerDetailQuery,

  useGetRenovationListQuery,
  useCreateRenovationMutation,
  useUpdateRenovationMutation,
  useGetSingleRenovationQuery,

  useGetSSSListQuery,
  useCreateSSSMutation,
  useUpdateSSSMutation,

  useGetSingleSSSQuery,

  useGetIPListQuery,
  useCreateIPMutation,
  useUpdateIPMutation,
  useGetSingleIPQuery,

  useGetSOIListQuery,
  useCreateSOIMutation,
  useUpdateSOIMutation,
  useGetSingleSOIQuery,

  useGetFSSListQuery,
  useCreateFSSMutation,
  useUpdateFSSMutation,
  useGetSingleFSSQuery,

  useGetKCCListQuery,
  useCreateKCCMutation,
  useUpdateKCCMutation,
  useGetSingleKCCQuery,

  useGetNotifiedListQuery,
  useCreateNotifiedMutation,
  useUpdateNotifiedMutation,
  useGetSingleNotifiedQuery,

  useGetPvtPondsListQuery,
  useCreatePvtPondsMutation,
  useEditPvtPondsQuery,
  useUpdatePvtPondsMutation,

  useGetLakeReservoirPondsListQuery,
  useCreatelakeReservoirPondsMutation,
  useEditLakeReservoirPondsQuery,
  useUpdateLakeReservoirPondsMutation,

  useGetWaterShedPondsListQuery,
  useCreatewaterShedsPondsMutation,
  useEditWaterShedPondsQuery,
  useUpdateWaterShedPondsMutation,

  //=========================Bank fetch for kcc api========================//
  useGetBankListQuery,
  useGetMprVehicleListQuery, //used for all mpr-list
  useGetschemeMprListQuery,
  useCreateMprBioFlocMutation,
  useEditMprBioFlocQuery,
  useUpdateMprBioFlocMutation,
  useLazyDownloadFarmerListQuery,
  useFinancialYearQuery,
  useListSaralDistSummaryQuery,
  useGetFarmerListQuery,
  useCreateFarmerMutation,
  useUpdateFarmerMutation,
  useGetFarmerByIdQuery,
  useGetPachExportedExcelQuery,
  useGetSaralDashboardRecordQuery,
  useGetSchemewiseSummaryofSaralSanctionsStateQuery,
  useGetSchemewiseSummaryofDistrictWiseQuery,
  useCreateStateTargetsMutation,
  useGetStateTargetListQuery,
  useGetIntensiveListQuery,
  useUpdateStateTargetMutation,
  useGetShowSaralStateListQuery,
  useGetShowSaralDisttListQuery,
  useGetStateAchievementsListQuery,
  useGetStateTargetListValuesQuery,
  useGetSaralApplicationDashboardQuery,
  useCreateFFStockMutation,
  useGetFFStockListQuery,
  useUpdateFFStockMutation,
  useGetSaralApplicationStatusDashboardDistrictWaiseQuery,
  useGetAllOrdersListQuery, 
  // useGetDashboardPieChartData,

  // useGetMprBioFlocListQuery,
  // useCreatePvtPondsMutation,
  // useUpdatePvtPondsMutation,

  useGetFTypeListQuery, //all farmer type
  useGetAllTrainingListQuery, //all Training type
  useGetAllLookupListQuery,
  useCreateDBTRecMutation,
  useGetDBTReportsQuery,
  useGetDBTByIdQuery,
  useUpdateDBTRecMutation,
  useGetStateIntensiveAchievementsListQuery,
  useGetStateAHDRAchievementsListQuery,
  useCreateOrnamentalEntryMutation,
  useUpdateOrnamentalEntryMutation,
  useGetOrnamentalEntryListQuery,
} = api;
